// tableFilterPersistance.tsx
// In-memory only: survives in-app navigation, resets on page refresh.

export interface SavedTableState {
    filters: Record<string, Set<string>>;
    sorts: Record<string, 'asc' | 'desc' | 'none'>;
}

const store = new Map<string, SavedTableState>();

export const getSavedTableState = (key: string) => store.get(key);

export const saveTableState = (key: string, state: SavedTableState) => {
    store.set(key, state);
};